import {AddressInputComponentController} from "./addressInput.controller";

export class AddressInputComponent implements ng.IComponentOptions {
    public bindings: any;
    public controller: any;
    public templateUrl: any;
    public controllerAs: string;


    constructor() {
        this.controller = AddressInputComponentController;
        this.controllerAs = 'vm';
        this.templateUrl = './modules/quoteWizard/components/addressInput/addressInput.view.html';
        this.bindings = {
            onBackBinding: '&',
            onNextBinding: '&',
            addressLineOneModelBinding: '=',
            addressLineTwoModelBinding: '=',
            cityModelBinding: '=',
            stateModelBinding: '=',
            zipModelBinding: '='
        };
    }
}
